import { Observable } from "rxjs";
import { tap, switchMap, mergeMap, debounceTime } from "rxjs/operators";
import { TCodecSetState, TGetCodecState } from "../applyActions";
import { formOperation } from "../../wrappers/formOperation";
import { TActionsDefinitionsList } from "./TAction";
import { action } from "./actionFunctions";
import { TStateLens } from "../../../../domain/codecs/state";
import {
    TManagementCompanySearchForm,
    TCreateCaseManagementCompanyForm,
    TCaseManagementCompanyForm,
} from "../../../../domain/codecs/form/ManagementCompanyForm";

const $loadManagementCompanies = <T>(lens: TStateLens, setState: TCodecSetState, getState: TGetCodecState) =>
    (obs$: Observable<T>) =>
        obs$.pipe(
            mergeMap(() => formOperation("GetCaseManagementCompanies", lens.case_management_companies.get()(getState()))),
            tap((response) => setState(lens.case_management_companies.set(response))),
        );

export const actions: TActionsDefinitionsList = [
    action("LEGAL_CASE_MCO_SEARCH", (obs$: Observable<TManagementCompanySearchForm>, lens, setState, getState) => {
        obs$.pipe(
            tap((payload) => setState(lens.case_management_companies.children.search.set(payload))),
            debounceTime(300),
            tap(() => setState(lens.case_management_companies.children.search.status.set("submitting"))),
            switchMap(() => formOperation("GetManagementCompanySearch", {
                ...lens.case_management_companies.children.search.get()(getState()),
                edited: {
                    ...lens.case_management_companies.children.search.edited.get()(getState()),
                    case_id: lens.case_management_companies.edited.case_id.get()(getState()),
                },
            })),
            tap((response) => setState(lens.case_management_companies.children.search.set(response))),
        ).subscribe();
    }),
    action("LEGAL_CASE_MCO_CREATE", (obs$: Observable<TCreateCaseManagementCompanyForm>, lens, setState, getState) => {
        obs$.pipe(
            tap((payload) => setState(lens.case_management_companies.children.create.set(payload))),
            tap(() => setState(lens.case_management_companies.children.create.status.set("submitting"))),
            switchMap(() => formOperation("CreateCaseManagementCompany", {
                ...lens.case_management_companies.children.create.get()(getState()),
                edited: {
                    ...lens.case_management_companies.children.create.edited.get()(getState()),
                    case_id: lens.case_management_companies.edited.case_id.get()(getState()),
                },
            })),
            tap((response) => setState(lens.case_management_companies.children.create.set(response))),
            $loadManagementCompanies(lens, setState, getState),
        ).subscribe();
    }),
    action("LEGAL_CASE_MCO_UPDATE", (obs$: Observable<TCaseManagementCompanyForm>, lens, setState, getState) => {
        obs$.pipe(
            tap((payload) => setState(lens.case_management_companies.children.items.where((f) => f.edited.link.id === payload.edited.link.id).set(payload))),
            debounceTime(1000),
            tap((payload) => setState(lens.case_management_companies.children.items.where((f) => f.edited.link.id === payload.edited.link.id).status.set("submitting"))),
            switchMap((payload) => formOperation("UpdateCaseManagementCompany", lens.case_management_companies.children.items.where((f) => f.edited.link.id === payload.edited.link.id).get()(getState()))),
            tap((response) => setState(lens.case_management_companies.children.items.where((f) => f.edited.link.id === response.edited.link.id).set(response))),
        ).subscribe();
    }),
    action("LEGAL_CASE_MCO_DELETE", (obs$: Observable<TCaseManagementCompanyForm>, lens, setState, getState) => {
        obs$.pipe(
            tap((payload) => setState(lens.case_management_companies.children.items.where((f) => f.edited.link.id === payload.edited.link.id).status.set("submitting"))),
            switchMap((payload) => formOperation("DeleteCaseManagementCompany", lens.case_management_companies.children.items.where((f) => f.edited.link.id === payload.edited.link.id).get()(getState()))),
            $loadManagementCompanies(lens, setState, getState),
        ).subscribe();
    }),
];
